import AuthApi from "../apis/AuthApi";

/**
 * 認証サービスクラス
 */
class AuthenticationService {
  /**
   * ログイン状態を確認する
   * @memberof AuthenticationService
   */
  async auth() {
    const result = await new AuthApi(this).auth();
    if (result.data?.success) {
      this.setEmployeeName(result.data.body?.employeeName);
      this.setEmployeeNo(result.data.body?.employeeNo);
    }
    return result;
  }
  /**
   * ログインする
   * @param {string} employeeNo 社員番号
   * @memberof AuthenticationService
   */
  async login(employeeNo) {
    const result = await new AuthApi(this).login(employeeNo);
    if (result.data?.success) {
      this.setEmployeeName(result.data.body?.employeeName);
      this.setEmployeeNo(result.data.body?.employeeNo);
    }
    return result;
  }
  /**
   * ログアウトする
   * @memberof AuthenticationService
   */
  async logout() {
    const result = await new AuthApi(this).logout();
    window.localStorage.removeItem("employeeName");
    window.localStorage.removeItem("employeeNo");
    return result;
  }
  /**
   * 社員名を LocalStorage に保存する
   * @param {string} name 社員名
   * @memberof AuthenticationService
   */
  setEmployeeName(name) {
    window.localStorage.setItem("employeeName", name);
  }
  /**
   * LocalStorage に保存した社員名を取得する
   * @memberof AuthenticationService
   */
  get employeeName() {
    return window.localStorage.getItem("employeeName");
  }
  /**
   * 社員番号を LocalStorage に保存する
   * @param {string} no 社員番号
   * @memberof AuthenticationService
   */
  setEmployeeNo(no) {
    window.localStorage.setItem("employeeNo", no);
  }
  /**
   * LocalStorage に保存した社員番号を取得する
   * @memberof AuthenticationService
   */
  get employeeNo() {
    return window.localStorage.getItem("employeeNo");
  }
}
export const authenticationService = new AuthenticationService();
